/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { Buttons, ChooseLocationModal } from 'components';
import { useSignal, useComputed } from '@preact/signals-react';

const ChooseLocationBtn = ({ isDisabled }) => {
  const isOpen$ = useSignal(false);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div style={{ padding: '16px' }}>
      <Buttons.SecondaryNormal
        id='location'
        style={{ width: '100%' }}
        isDisabled={isDisabled}
        onClick={() => (isOpen$.value = true)}
      >
        Choose Countries
      </Buttons.SecondaryNormal>
      {useComputed(() => (
        <>
          {isOpen$.value && (
            <ChooseLocationModal title='Countries' close={() => (isOpen$.value = false)} />
          )}
        </>
      ))}
    </div>
  );
};

export default ChooseLocationBtn;
